import React, { createContext, useContext, useEffect, useState } from 'react';
import { useCreditsService } from '../services/creditsService';

const CreditsContext = createContext();

export const CreditsProvider = ({ children }) => {
    const { getUserCredits } = useCreditsService();

    const [credits, setCredits] = useState(null);
    const [report, setReport] = useState(null);

    const updateCredits = value => {
        setCredits(value);
    };

    const updateReport = value => {
        setReport(value);
    };

    useEffect(() => {
        const fetchCredits = async () => {
            try {
                const newCredits = await getUserCredits();
                updateCredits(newCredits);
            } catch (error) {
                console.error('Error fetching credits:', error);
            }
        };

        fetchCredits();
    }, [report]);

    return (
        <CreditsContext.Provider value={{ credits, updateCredits, report, updateReport }}>
            {children}
        </CreditsContext.Provider>
    );
};

export const useCredits = () => useContext(CreditsContext);
